export default function createFooterData({globalContextObj} = {}) {
	let serverOrgin = globalContextObj.serverOrigin;
	return [
		[
			{
				name: 'The B.R.U.G. Method',
				link: '/',
			},
			{
				name: 'Home',
				link: '/home',
			},
			{
				name: 'Courses',
				link: '/courses',
			},
			{
				name: 'Support',
				link: '/support',
			},
			{
				name: 'Contact Me',
				link: '/contact',
			},
			{
				name: 'Sign In',
				link: '/signin',
			},
			{
				name: 'Sign up',
				link: '/signup',
			},
		],
		[
			{
				name: 'Instagram',
				link: 'https://www.instagram.com/brugjosh/',
			},
			{
				name: 'Linkedin',
				link: 'https://www.linkedin.com/in/josh-penaranda-ingles-52286a1b9/',
			},
		],

		[
			{
				name: 'Email: brugmethod@gmail.com',
				link: '',
			},
		],
		[
			{
				name: 'Credentials PDF',
				link: `${serverOrgin}/downloadcredentials`,
			},
			{
				name: 'Photo Credit',
				link: '/photocredit',
			},
			{
				name: 'Terms and Conditions',
				link: '/terms',
			},
		],
	];
}
